import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Building Orgs illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-building-orgs',
    styleUrl: 'building-orgs.css',
    shadow: true,
})
export class EsIllustrationBuildingOrgs {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 692.1 858.5"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="building_orgs_c"
                        x1="642.7"
                        x2="666"
                        y1="-446.9"
                        y2="-406.7"
                        gradientTransform="translate(-165 689.2)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#fff" />
                        <stop offset="1" stop-color="#bbdefb" />
                    </linearGradient>
                </defs>
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="m106 229.1 206.7 108.7v324.7l-22.5 78-60.9-9.3s-70.2-51.3-73.1-53.3-51.5-109.8-52.9-114.6-2.7-92.1 0-100.8-3.7-129.3-1.5-132.7 4.2-100.7 4.2-100.7Z"
                />
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="m132.9 316.2 52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 42.9-4.2 45.6s5.8 14.2 5.8 14.2ZM238.9 377.1l52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 43-4.2 45.6s5.8 14.2 5.8 14.2ZM239.9 470.1l52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 43-4.2 45.6s5.8 14.2 5.8 14.2ZM135.8 408.1l52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 43-4.2 45.6s5.8 14.2 5.8 14.2ZM240.8 563.1l52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 43-4.2 45.6s5.8 14.2 5.8 14.2ZM134.8 503.1l52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 43-4.2 45.6s5.8 14.2 5.8 14.2ZM182.9 688l62.3-36-5.4-33.6-52.5-29.1s-14.6 4.9-15 12.9 3.6 44.9 3.6 50 7 35.8 7 35.8Z"
                />
                <path
                    id="building_orgs_b"
                    fill="#fff"
                    fill-rule="evenodd"
                    d="m348.2 443.3-16.4-9.5c-5.4-3-9.8-.5-9.8 6v19.3l367.1 212v-19.3c0-6.5-4.4-14.1-9.8-17.3l-16.4-9.5"
                />
                <path
                    fill="#fff"
                    d="m652.3 649.5-16.3-9.4v-441c0-12.8-8.8-28.3-19.7-34.5L340.9 5.7c-6.2-3.6-11.7-3.4-15.3-.2L60 158.1l261.2 145.1v155.1l-16.4-9.5c-5.4-3.1-9.8-.5-9.8 5.9V474l74 42.7v276.4l240.1-137.6 53 30.6v-19.3c0-6.5-4.4-14.2-9.8-17.3Z"
                />
                <path
                    fill="#bbdefb"
                    d="M361 358.8 633.7 205.7 637.3 192 637.3 197 636 640 368.9 793 361 358.8z"
                />
                <path
                    fill="url(#building_orgs_c)"
                    fill-rule="evenodd"
                    d="M368.9 358.8 636 204.6c-.9-15.9-12.5-33.2-21-41.6L338.4 322.7l30.6 36Z"
                />
                <path
                    id="building_orgs_d"
                    fill="#fff"
                    fill-rule="evenodd"
                    d="m385.3 802.5-16.4-9.5V352.1c0-12.8-8.8-28.3-19.7-34.6l-275.3-159c-10.9-6.3-19.7-1-19.7 11.8v440.8l-16.4-9.5c-5.4-3-9.8-.5-9.8 6v19.2l367.1 212.3v-19.3c0-6.5-4.4-14.2-9.8-17.3ZM132.9 266.2c0-6.4 4.4-9.1 9.8-5.9l32.8 18.9c5.4 3.1 9.8 10.9 9.8 17.2v38.7c0 6.5-4.4 9.1-9.8 6l-32.8-18.9c-5.4-3.1-9.8-10.9-9.8-17.3v-38.7Zm0 92.8c0-6.4 4.4-9.1 9.8-5.9l32.8 18.9c5.4 3.1 9.8 10.9 9.8 17.3V428c0 6.4-4.4 9.1-9.8 5.9L142.7 415c-5.4-3.1-9.8-10.9-9.8-17.3V359Zm42.6 167.7-32.8-18.9c-5.4-3.1-9.8-11-9.8-17.3v-38.7c0-6.5 4.4-9.1 9.8-6l32.8 19c5.4 3 9.8 10.9 9.8 17.3v38.7c0 6.4-4.4 9-9.8 5.9Zm62.3 190.6-52.5-30.2v-81.3c0-6.4 4.4-9 9.8-5.9l32.8 18.9c5.4 3.1 9.8 11 9.8 17.3v81.1Zm52.4-135.9c0 6.4-4.4 9.1-9.8 5.9l-32.8-18.9c-5.4-3.1-9.8-10.9-9.8-17.3v-38.7c0-6.5 4.4-9.1 9.8-6l32.8 19c5.4 3 9.8 10.9 9.8 17.3v38.7Zm0-92.8c0 6.4-4.4 9.1-9.8 5.9l-32.8-18.9c-5.4-3.1-9.8-10.9-9.8-17.3v-38.7c0-6.4 4.4-9.1 9.8-5.9l32.8 18.9c5.4 3.1 9.8 10.9 9.8 17.3v38.7Zm0-92.8c0 6.4-4.4 9.1-9.8 5.9l-32.8-18.9c-5.4-3.1-9.8-10.9-9.8-17.3v-38.7c0-6.4 4.4-9.1 9.8-5.9l32.8 18.9c5.4 3.1 9.8 10.9 9.8 17.3v38.7Z"
                />
                <path
                    fill="#1a4e85"
                    d="M248.3 319.6c-3.1-1.8-6-2-8.4-.8s-3.7 4.3-3.7 7.9v24.6h3v-24.5c0-2.5.8-4.5 2.2-5.3.5-.4 1.2-.6 1.8-.5 1.3 0 2.5.4 3.6 1.1l23.5 13.6c.6-.9 1.5-1.6 2.4-2.1l-24.4-14ZM288.7 375.1v20.5c0 2.5-.8 4.5-2.2 5.3s-3.3.6-5.4-.7l-22.7-13.1c0 1.1-.3 2.1-.7 3.1l21.9 12.6c1.5 1 3.3 1.5 5.1 1.5 1.2 0 2.3-.3 3.3-.9 2.4-1.4 3.7-4.1 3.7-7.8v-19.3c-1.1 0-2.2-.4-3-1.2ZM145.3 201.3c0-.9.3-1.8.6-2.7l-63-36.4c-.2.4-.4.7-.7 1-.2.5-.4 1.1-.5 1.7l63.4 36.6c0-.2 0-.2.2-.2Z"
                />
                <path
                    fill="#1a4e85"
                    d="m350 316.3-157.7-91c0 1.1-.2 2.1-.8 3l157 90.8c10.4 6 18.9 20.9 18.9 33.2v113.8l3 .2V352.1c0-13.3-9.2-29.3-20.4-35.8ZM370.4 706.8v-86.7c-1 0-2 .2-3 .4v86l3 .3ZM256 416.8l-7.7-4.5c-3.1-1.7-6-2-8.4-.7s-3.7 4.2-3.7 8v35.7c.9-.6 1.9-.9 3-1v-34.7c0-2.5.8-4.5 2.2-5.3.5-.4 1.2-.6 1.8-.5 1.3 0 2.5.4 3.6 1l8.2 4.8c0-1 .4-2 1-2.8ZM286.6 436.1c-.1 1.2-.7 2.2-1.6 3 2.2 3.1 3.5 6.9 3.7 10.7v38.7c0 2.5-.8 4.5-2.2 5.3s-3.3.5-5.4-.7l-13.2-7.6c-.6.9-1.5 1.5-2.6 1.7h-.4l14.7 8.5c1.6.9 3.3 1.4 5.1 1.5 1.2 0 2.3-.3 3.3-.9 2.4-1.5 3.7-4.1 3.7-7.8v-38.9c0-4.3-2-9.5-5.1-13.5ZM134.4 304.8v-28.2c-1 0-2.1-.2-3-.7v29c0 7 4.6 15.3 10.6 18.7l10.7 6.2c.1-.9.3-1.7.5-2.6 0-.3.1-.3.2-.5l-9.9-5.8c-5-3-9.1-10.1-9.1-16.1ZM176.2 277.8l-7.3-4.2c-.1 1.1-.3 2.1-.5 3.2l6.3 3.6c5 2.9 9.1 10.2 9.1 16v25.2c1.1 0 2.2.5 3 1.2v-26.4c0-7-4.6-15.1-10.6-18.6ZM288.7 542.6v31.7l3 .6v-32.3c0-7-4.6-15.2-10.6-18.5l-24.1-14v3.5l22.6 13c5 3 9.1 10.2 9.1 16ZM271.3 580.3l-22.9-13.2c-5-3-9.1-10.1-9.1-16V530c-1-.1-2-.4-3-.8v21.9c0 7 4.6 15.2 10.6 18.5l23.8 13.7c.1-1 .3-2 .6-3ZM152.9 511.8l-9.4-5.4c-5-2.9-9.1-10.1-9.1-16v-20.6l-3-.2v21c0 7 4.6 15 10.6 18.5l11.5 6.6c-.2-1.4-.4-2.6-.6-3.9ZM176.2 463.5 151 449c0 1.2.1 2.4.2 3.6l23.5 13.5c5 3 9.1 10.1 9.1 16v38.7c0 2.5-.8 4.5-2.2 5.3-.6.4-1.4.6-2.1.5 0 1-.1 2.1-.6 3h.9c1.2 0 2.3-.3 3.3-.9 2.4-1.4 3.7-4.2 3.7-7.9v-38.7c0-7-4.6-15.1-10.6-18.6ZM186.3 404.6c-.9 0-1.7 0-2.5-.5V428c0 2.5-.8 4.5-2.2 5.3s-3.3.5-5.4-.7l-12.9-7.5c.5 1.1.5 2.4 0 3.5l11.4 6.5c1.5 1 3.3 1.5 5.1 1.5 1.2 0 2.3-.3 3.3-.9 2.4-1.4 3.7-4.2 3.7-7.9v-22.7l-.5-.5ZM161.2 363.1c0-.4-.1-.7-.1-1.1l-17.6-10.2c-3.1-1.8-6-2-8.4-.7s-3.7 4.2-3.7 7.9v31.1h.3c.9-.4 1.8-.4 2.7 0v-31c0-2.5.8-4.5 2.2-5.3.5-.4 1.2-.6 1.8-.5 1.3 0 2.5.4 3.6 1l19.6 11.3c0-.8-.2-1.7-.4-2.5ZM236.3 636.1v68.5c1 0 2 .2 3 .5v-69c0-7-4.6-15.3-10.6-18.6l-32.8-18.9c-3.1-1.8-6-2-8.4-.8s-3.7 4.3-3.7 8v48.5c1-.4 2-.4 3 0v-48.5c0-2.5.8-4.5 2.2-5.3s3.3-.6 5.4.7l32.8 18.9c5 2.9 9.1 10 9.1 16Z"
                />
                <path
                    id="building_orgs_e"
                    fill="#fff"
                    fill-rule="evenodd"
                    d="m29.2 627.3-16.4-9.5c-5.4-3-9.8-.5-9.8 6v19.3l367.1 212v-19.3c0-6.5-4.4-14.1-9.8-17.3l-16.4-9.5"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M368.9 793 636 640 636 610.1 674.4 636 689.1 671 370.1 855 7.1 616.8 54.2 585 54.2 611.4 368.9 793z"
                />
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="M689.1 671 687.7 641.4 370.1 826.3 370.1 855 689.1 671z"
                />
                <path
                    fill="#1a4e85"
                    d="m343.3 807-302-174.4c-.3 1-.5 2-.8 3l301.2 173.9 1.6-2.5Z"
                />
                <path
                    fill="none"
                    stroke="#1a4e85"
                    stroke-miterlimit="10"
                    stroke-width="6"
                    d="m679.3 634.5-16.4-9.5-26.9-15.5V199.1c0-12.8-8.8-28.3-19.7-34.5L340.9 5.7c-6.2-3.6-11.7-3.4-15.3-.2L63.2 156.3c-5.4 1-9 6.1-9 14.3v414.5L7.1 616.8c-2.7 1.2-4.3 4-4.1 7v19.3l367.1 212 319-184v-19.3c0-6.5-4.4-14.2-9.8-17.3Z"
                />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 692.1 858.5"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="building_orgs_c"
                        x1="642.7"
                        x2="666"
                        y1="-446.9"
                        y2="-406.7"
                        gradientTransform="translate(-165 689.2)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#ced4db" />
                        <stop offset="1" stop-color="#09264a" />
                    </linearGradient>
                </defs>
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="m106 229.1 206.7 108.7v324.7l-22.5 78-60.9-9.3s-70.2-51.3-73.1-53.3-51.5-109.8-52.9-114.6-2.7-92.1 0-100.8-3.7-129.3-1.5-132.7 4.2-100.7 4.2-100.7Z"
                />
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="m132.9 316.2 52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 42.9-4.2 45.6s5.8 14.2 5.8 14.2ZM238.9 377.1l52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 43-4.2 45.6s5.8 14.2 5.8 14.2ZM239.9 470.1l52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 43-4.2 45.6s5.8 14.2 5.8 14.2ZM135.8 408.1l52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 43-4.2 45.6s5.8 14.2 5.8 14.2ZM240.8 563.1l52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 43-4.2 45.6s5.8 14.2 5.8 14.2ZM134.8 503.1l52.4-32-47.1-31.8-6.9 4c-2.2 1.3-4.2 43-4.2 45.6s5.8 14.2 5.8 14.2ZM182.9 688l62.3-36-5.4-33.6-52.5-29.1s-14.6 4.9-15 12.9 3.6 44.9 3.6 50 7 35.8 7 35.8Z"
                />
                <path
                    id="building_orgs_b"
                    fill="#fff"
                    fill-rule="evenodd"
                    d="m348.2 443.3-16.4-9.5c-5.4-3-9.8-.5-9.8 6v19.3l367.1 212v-19.3c0-6.5-4.4-14.1-9.8-17.3l-16.4-9.5"
                />
                <path
                    fill="#ced4db"
                    d="m652.3 649.5-16.3-9.4v-441c0-12.8-8.8-28.3-19.7-34.5L340.9 5.7c-6.2-3.6-11.7-3.4-15.3-.2L60 158.1l261.2 145.1v155.1l-16.4-9.5c-5.4-3.1-9.8-.5-9.8 5.9V474l74 42.7v276.4l240.1-137.6 53 30.6v-19.3c0-6.5-4.4-14.2-9.8-17.3Z"
                />
                <path
                    fill="#09264a"
                    d="M361 358.8 633.7 205.7 637.3 192 637.3 197 636 640 368.9 793 361 358.8z"
                />
                <path
                    fill="url(#building_orgs_c)"
                    fill-rule="evenodd"
                    d="M368.9 358.8 636 204.6c-.9-15.9-12.5-33.2-21-41.6L338.4 322.7l30.6 36Z"
                />
                <path
                    id="building_orgs_d"
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="m385.3 802.5-16.4-9.5V352.1c0-12.8-8.8-28.3-19.7-34.6l-275.3-159c-10.9-6.3-19.7-1-19.7 11.8v440.8l-16.4-9.5c-5.4-3-9.8-.5-9.8 6v19.2l367.1 212.3v-19.3c0-6.5-4.4-14.2-9.8-17.3ZM132.9 266.2c0-6.4 4.4-9.1 9.8-5.9l32.8 18.9c5.4 3.1 9.8 10.9 9.8 17.2v38.7c0 6.5-4.4 9.1-9.8 6l-32.8-18.9c-5.4-3.1-9.8-10.9-9.8-17.3v-38.7Zm0 92.8c0-6.4 4.4-9.1 9.8-5.9l32.8 18.9c5.4 3.1 9.8 10.9 9.8 17.3V428c0 6.4-4.4 9.1-9.8 5.9L142.7 415c-5.4-3.1-9.8-10.9-9.8-17.3V359Zm42.6 167.7-32.8-18.9c-5.4-3.1-9.8-11-9.8-17.3v-38.7c0-6.5 4.4-9.1 9.8-6l32.8 19c5.4 3 9.8 10.9 9.8 17.3v38.7c0 6.4-4.4 9-9.8 5.9Zm62.3 190.6-52.5-30.2v-81.3c0-6.4 4.4-9 9.8-5.9l32.8 18.9c5.4 3.1 9.8 11 9.8 17.3v81.1Zm52.4-135.9c0 6.4-4.4 9.1-9.8 5.9l-32.8-18.9c-5.4-3.1-9.8-10.9-9.8-17.3v-38.7c0-6.5 4.4-9.1 9.8-6l32.8 19c5.4 3 9.8 10.9 9.8 17.3v38.7Zm0-92.8c0 6.4-4.4 9.1-9.8 5.9l-32.8-18.9c-5.4-3.1-9.8-10.9-9.8-17.3v-38.7c0-6.4 4.4-9.1 9.8-5.9l32.8 18.9c5.4 3.1 9.8 10.9 9.8 17.3v38.7Zm0-92.8c0 6.4-4.4 9.1-9.8 5.9l-32.8-18.9c-5.4-3.1-9.8-10.9-9.8-17.3v-38.7c0-6.4 4.4-9.1 9.8-5.9l32.8 18.9c5.4 3.1 9.8 10.9 9.8 17.3v38.7Z"
                />
                <path
                    fill="#09264a"
                    d="M248.3 319.6c-3.1-1.8-6-2-8.4-.8s-3.7 4.3-3.7 7.9v24.6h3v-24.5c0-2.5.8-4.5 2.2-5.3.5-.4 1.2-.6 1.8-.5 1.3 0 2.5.4 3.6 1.1l23.5 13.6c.6-.9 1.5-1.6 2.4-2.1l-24.4-14ZM288.7 375.1v20.5c0 2.5-.8 4.5-2.2 5.3s-3.3.6-5.4-.7l-22.7-13.1c0 1.1-.3 2.1-.7 3.1l21.9 12.6c1.5 1 3.3 1.5 5.1 1.5 1.2 0 2.3-.3 3.3-.9 2.4-1.4 3.7-4.1 3.7-7.8v-19.3c-1.1 0-2.2-.4-3-1.2ZM145.3 201.3c0-.9.3-1.8.6-2.7l-63-36.4c-.2.4-.4.7-.7 1-.2.5-.4 1.1-.5 1.7l63.4 36.6c0-.2 0-.2.2-.2Z"
                />
                <path
                    fill="#09264a"
                    d="m350 316.3-157.7-91c0 1.1-.2 2.1-.8 3l157 90.8c10.4 6 18.9 20.9 18.9 33.2v113.8l3 .2V352.1c0-13.3-9.2-29.3-20.4-35.8ZM370.4 706.8v-86.7c-1 0-2 .2-3 .4v86l3 .3ZM256 416.8l-7.7-4.5c-3.1-1.7-6-2-8.4-.7s-3.7 4.2-3.7 8v35.7c.9-.6 1.9-.9 3-1v-34.7c0-2.5.8-4.5 2.2-5.3.5-.4 1.2-.6 1.8-.5 1.3 0 2.5.4 3.6 1l8.2 4.8c0-1 .4-2 1-2.8ZM286.6 436.1c-.1 1.2-.7 2.2-1.6 3 2.2 3.1 3.5 6.9 3.7 10.7v38.7c0 2.5-.8 4.5-2.2 5.3s-3.3.5-5.4-.7l-13.2-7.6c-.6.9-1.5 1.5-2.6 1.7h-.4l14.7 8.5c1.6.9 3.3 1.4 5.1 1.5 1.2 0 2.3-.3 3.3-.9 2.4-1.5 3.7-4.1 3.7-7.8v-38.9c0-4.3-2-9.5-5.1-13.5ZM134.4 304.8v-28.2c-1 0-2.1-.2-3-.7v29c0 7 4.6 15.3 10.6 18.7l10.7 6.2c.1-.9.3-1.7.5-2.6 0-.3.1-.3.2-.5l-9.9-5.8c-5-3-9.1-10.1-9.1-16.1ZM176.2 277.8l-7.3-4.2c-.1 1.1-.3 2.1-.5 3.2l6.3 3.6c5 2.9 9.1 10.2 9.1 16v25.2c1.1 0 2.2.5 3 1.2v-26.4c0-7-4.6-15.1-10.6-18.6ZM288.7 542.6v31.7l3 .6v-32.3c0-7-4.6-15.2-10.6-18.5l-24.1-14v3.5l22.6 13c5 3 9.1 10.2 9.1 16ZM271.3 580.3l-22.9-13.2c-5-3-9.1-10.1-9.1-16V530c-1-.1-2-.4-3-.8v21.9c0 7 4.6 15.2 10.6 18.5l23.8 13.7c.1-1 .3-2 .6-3ZM152.9 511.8l-9.4-5.4c-5-2.9-9.1-10.1-9.1-16v-20.6l-3-.2v21c0 7 4.6 15 10.6 18.5l11.5 6.6c-.2-1.4-.4-2.6-.6-3.9ZM176.2 463.5 151 449c0 1.2.1 2.4.2 3.6l23.5 13.5c5 3 9.1 10.1 9.1 16v38.7c0 2.5-.8 4.5-2.2 5.3-.6.4-1.4.6-2.1.5 0 1-.1 2.1-.6 3h.9c1.2 0 2.3-.3 3.3-.9 2.4-1.4 3.7-4.2 3.7-7.9v-38.7c0-7-4.6-15.1-10.6-18.6ZM186.3 404.6c-.9 0-1.7 0-2.5-.5V428c0 2.5-.8 4.5-2.2 5.3s-3.3.5-5.4-.7l-12.9-7.5c.5 1.1.5 2.4 0 3.5l11.4 6.5c1.5 1 3.3 1.5 5.1 1.5 1.2 0 2.3-.3 3.3-.9 2.4-1.4 3.7-4.2 3.7-7.9v-22.7l-.5-.5ZM161.2 363.1c0-.4-.1-.7-.1-1.1l-17.6-10.2c-3.1-1.8-6-2-8.4-.7s-3.7 4.2-3.7 7.9v31.1h.3c.9-.4 1.8-.4 2.7 0v-31c0-2.5.8-4.5 2.2-5.3.5-.4 1.2-.6 1.8-.5 1.3 0 2.5.4 3.6 1l19.6 11.3c0-.8-.2-1.7-.4-2.5ZM236.3 636.1v68.5c1 0 2 .2 3 .5v-69c0-7-4.6-15.3-10.6-18.6l-32.8-18.9c-3.1-1.8-6-2-8.4-.8s-3.7 4.3-3.7 8v48.5c1-.4 2-.4 3 0v-48.5c0-2.5.8-4.5 2.2-5.3s3.3-.6 5.4.7l32.8 18.9c5 2.9 9.1 10 9.1 16Z"
                />
                <path
                    id="building_orgs_e"
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="m29.2 627.3-16.4-9.5c-5.4-3-9.8-.5-9.8 6v19.3l367.1 212v-19.3c0-6.5-4.4-14.1-9.8-17.3l-16.4-9.5"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M368.9 793 636 640 636 610.1 684.1 636.6 689.1 671 370.1 855 7.1 616.8 54.2 585 54.2 611.4 368.9 793z"
                />
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="M689.1 671 687.7 641.4 370.1 826.3 370.1 855 689.1 671z"
                />
                <path
                    fill="#09264a"
                    d="m343.3 807-302-174.4c-.3 1-.5 2-.8 3l301.2 173.9 1.6-2.5Z"
                />
                <path
                    fill="none"
                    stroke="#fff"
                    stroke-miterlimit="10"
                    stroke-width="6"
                    d="m679.3 634.5-16.4-9.5-26.9-15.5V199.1c0-12.8-8.8-28.3-19.7-34.5L340.9 5.7c-6.2-3.6-11.7-3.4-15.3-.2L63.2 156.3c-5.4 1-9 6.1-9 14.3v414.5L7.1 616.8c-2.7 1.2-4.3 4-4.1 7v19.3l367.1 212 319-184v-19.3c0-6.5-4.4-14.2-9.8-17.3Z"
                />
            </svg>
        );
    }
}
